import { type BoardAncestors, type Library } from '@air/types';

import { useGeneralLibraryTitle } from '~/components/LibraryBeta/hooks/useGeneralLibraryTitle';
import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export type UsePrivateBoardAncestorsStringParams = {
  ancestors: BoardAncestors | undefined;
  library: Pick<Library, 'title'> | undefined;
};

export const usePrivateBoardAncestorsString = ({ ancestors, library }: UsePrivateBoardAncestorsStringParams) => {
  const { libraries } = usePrivateAddOnFeatures();
  const { currentWorkspace } = useCurrentWorkspace();
  const { generalLibraryTitle } = useGeneralLibraryTitle();

  let ancestorsString: string | undefined;

  if (!ancestors?.length) {
    if (libraries) {
      ancestorsString = library?.title ?? generalLibraryTitle;
    } else {
      ancestorsString = currentWorkspace?.name;
    }
  } else {
    const nearestAncestorTitle = ancestors[ancestors.length - 1].title;

    ancestorsString = ancestors.length > 1 ? `··· / ${nearestAncestorTitle}` : nearestAncestorTitle;
  }

  return {
    ancestorsString,
  };
};
